import { Clip } from '@stores/MomentMerge/MomentMergeStore';
import { useCallback } from 'react';

interface UseVideoEventHandlersParams {
  handleTimeUpdate: (
    videoRef: React.RefObject<HTMLVideoElement | null>,
    clipData: Clip | null,
  ) => void;
  video1Ref: React.RefObject<HTMLVideoElement | null>;
  video2Ref: React.RefObject<HTMLVideoElement | null>;
  video1Clip: Clip | null;
  video2Clip: Clip | null;
  onVideoEnded: () => void;
}

export const useVideoEventHandlers = ({
  handleTimeUpdate,
  video1Ref,
  video2Ref,
  video1Clip,
  video2Clip,
  onVideoEnded,
}: UseVideoEventHandlersParams) => {
  const handleVideo1TimeUpdate = useCallback(() => {
    handleTimeUpdate(video1Ref, video1Clip);
  }, [handleTimeUpdate, video1Ref, video1Clip]);

  const handleVideo2TimeUpdate = useCallback(() => {
    handleTimeUpdate(video2Ref, video2Clip);
  }, [handleTimeUpdate, video2Ref, video2Clip]);

  const handleVideoEnded = useCallback(() => {
    onVideoEnded();
  }, [onVideoEnded]);

  return {
    handleVideo1TimeUpdate,
    handleVideo2TimeUpdate,
    handleVideoEnded,
  };
};
